import { MatchStatus } from '@okletsplay/core';
import { MatchEntity } from 'app/interfaces/entity';
import React, { FC, useMemo } from 'react';

export const withMatchStatus =
  <T extends { entity: MatchEntity }>(Component: FC<T>, statuses: MatchStatus[] = []) =>
  ({ ...props }: T): JSX.Element | null => {
    const isComponentAvailable = useMemo(
      () => statuses.includes(props.entity?.status),
      [props.entity?.status]
    );

    return isComponentAvailable ? <Component {...props} /> : null;
  };
